import React, { useState, useEffect } from 'react';
import { markService } from '../../services/api';
import toast from 'react-hot-toast';

const MarksCard = () => {
  const [marks, setMarks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchMarks();
  }, []);

  const fetchMarks = async () => {
    try {
      const studentId = localStorage.getItem('studentId');
      if (!studentId) {
        toast.error('Student ID not found');
        return;
      }
      const response = await markService.getByStudent(studentId);
      setMarks(response.data.data || []);
    } catch (error) {
      console.error('Error fetching marks:', error);
      toast.error('Failed to load marks');
    } finally {
      setLoading(false);
    }
  };

  const getGradeColor = (grade) => {
    const colors = {
      'A+': 'bg-green-100 text-green-800',
      'A': 'bg-blue-100 text-blue-800',
      'A-': 'bg-cyan-100 text-cyan-800',
      'B+': 'bg-yellow-100 text-yellow-800',
      'B': 'bg-orange-100 text-orange-800',
      'C': 'bg-red-100 text-red-800',
      'F': 'bg-red-200 text-red-900'
    };
    return colors[grade] || 'bg-gray-100 text-gray-800';
  };

  const totalMarks = marks.reduce((sum, m) => sum + (m.totalMarks || 0), 0);
  const average = marks.length > 0 ? Math.round(totalMarks / marks.length) : 0;

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return (
    <div className="max-w-4xl mx-auto p-6">
      <h1 className="text-2xl font-bold text-gray-800 mb-6">Marks Card</h1>
      
      {marks.length === 0 ? (
        <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-8 text-center text-gray-500">
          No marks available
        </div>
      ) : (
        <>
          <div className="grid grid-cols-3 gap-4 mb-6">
            <div className="bg-blue-50 rounded-xl p-4 text-center">
              <p className="text-sm text-gray-600">Subjects</p>
              <p className="text-2xl font-bold text-blue-700">{marks.length}</p>
            </div>
            <div className="bg-green-50 rounded-xl p-4 text-center">
              <p className="text-sm text-gray-600">Average</p>
              <p className="text-2xl font-bold text-green-700">{average}%</p>
            </div>
            <div className="bg-purple-50 rounded-xl p-4 text-center">
              <p className="text-sm text-gray-600">Total</p>
              <p className="text-2xl font-bold text-purple-700">{totalMarks}</p>
            </div>
          </div>

          <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
            <table className="w-full">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">Subject</th>
                  <th className="px-4 py-3 text-center text-sm font-semibold text-gray-600">Internal</th>
                  <th className="px-4 py-3 text-center text-sm font-semibold text-gray-600">External</th>
                  <th className="px-4 py-3 text-center text-sm font-semibold text-gray-600">Total</th>
                  <th className="px-4 py-3 text-center text-sm font-semibold text-gray-600">Grade</th>
                </tr>
              </thead>
              <tbody>
                {marks.map((mark, index) => (
                  <tr key={mark._id || index} className="border-b hover:bg-gray-50">
                    <td className="px-4 py-3 font-medium">{mark.subject}</td>
                    <td className="px-4 py-3 text-center">{mark.internal || '-'}</td>
                    <td className="px-4 py-3 text-center">{mark.external || '-'}</td>
                    <td className="px-4 py-3 text-center font-bold">{mark.totalMarks || 0}</td>
                    <td className="px-4 py-3 text-center">
                      <span className={`px-2 py-1 rounded-full text-sm font-semibold ${getGradeColor(mark.grade)}`}>
                        {mark.grade || 'N/A'}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
};

export default MarksCard;
